var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubstack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.012 4.95943L20.012 2.44407H3.87305V4.95943H20.012ZM20.012 9.48146V6.80343H3.87305L3.87305 9.48196L20.012 9.48146ZM20.1275 21.556V11.4655C20.1275 11.3835 19.641 11.4115 19.184 11.4115H4.70055C4.24355 11.4115 3.87305 11.384 3.87305 11.4655V21.4095C4.01355 21.328 11.5435 17.3035 11.9575 17.1105C12.2155 17.259 18.7805 20.7795 20.1275 21.556Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstack);
export default __webpack_public_path__ + "static/media/substack.d3ef3f102ba47cdfc6d99eb8ec76787e.svg";
export { ForwardRef as ReactComponent };